module.exports = __webpack_public_path__ + "img/947-29a279.png";